// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/ricarica/sessioni/:id',
    requestBody: null,
    response: '{success:true,data:{id,transactionId,colonnina,connettore,dipendente,codiceBadge,inizioAt,fineAt,energiaWh,prezzoKwh,importo,stato,motivoAnomalia,tardiva,competenza,meterStartWh,meterStopWh,motivoStop,ultimoEventoAt,tariffaMancante,log:[{createdAt,utenteName,azione,dettaglio}]}}'
  },
  {
    method: 'POST',
    endpoint: '/api/ricarica/sessioni/:id/conferma',
    requestBody: '{dipendenteId,energiaWh,fineAt,prezzoKwh,nota,ultimoEventoAt}',
    response: '{success:true,data:{id,transactionId,stato,energiaWh,prezzoKwh,importo,competenza}}'
  },
  {
    method: 'GET',
    endpoint: '/api/ricarica/colonnine/elenco?societaId',
    requestBody: null,
    response: '{success:true,data:[{id,nome,sede}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/ricarica/sedi?societaId',
    requestBody: null,
    response: '{success:true,data:[{id,nome}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/ricarica/dipendenti?societaId',
    requestBody: null,
    response: '{success:true,data:[{id,nome,cognome}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/ricarica/sessioni?societaId&anno&mese&stato&colonninaId&sedeId&dipendenteId&q',
    requestBody: null,
    response: '{success:true,data:{sessioni:[{id,transactionId,colonnina,connettore,dipendente,codiceBadge,inizioAt,fineAt,energiaWh,prezzoKwh,importo,stato,motivoAnomalia,tardiva,competenza}],troncato,totali:{sessioni,energiaWh,importo,anomale}}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
